export enum MobileIdStatus {
	WAITING = 'waiting',
	SUCCESS = 'success',
	OTP_CASCADE = 'otp_cascade',
}
